export default {
  number: [
    "equalTo",
    "notEqualTo",
    "greaterThan",
    "greaterThanOrEqualTo",
    "lessThan",
    "lessThanOrEqualTo",
    "between",
    "notBetween"
  ],
  string: ["contains", "doesNotContain"]
};
